export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }